export default __webpack_public_path__ + "static/media/Logo.30d19c92.png";